<button
    mat-button
    [matMenuTriggerFor]="workspacesMenu"
    class="dark:text-[#E9EDEF] text-[#1e293b]"
>
    <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_outline:building-office-2'"
    ></mat-icon>
    <span class="hidden sm:inline ml-2">{{ selectedWorkspace?.name || 'Workspace' }}</span>
    @if (currentUserRole) {
        <span
            class="ml-2 px-1.5 py-0.5 text-xs rounded-full"
            [ngClass]="{
                'bg-amber-500/10 dark:bg-amber-500/20 text-amber-600 dark:text-amber-400': currentUserRole === 'admin',
                'bg-purple-500/10 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400': currentUserRole === 'supervisor',
                'bg-emerald-500/10 dark:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400': currentUserRole === 'configurator',
                'bg-blue-500/10 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400': currentUserRole === 'agent'
            }"
        >
            {{ ('workspaces.roles.' + currentUserRole) | transloco }}
        </span>
    }
</button>

<!-- Workspace menu -->
<mat-menu
    [xPosition]="'before'"
    #workspacesMenu="matMenu"
    class="dark:bg-[#233138] bg-white"
>
    @for (workspace of workspaces; track workspace._id) {
        <button
            mat-menu-item
            [ngClass]="{
                'dark:text-[#E9EDEF] text-[#1e293b]': true,
                'dark:bg-[#182229] bg-[#f8fafc]': workspace._id === selectedWorkspace?._id,
                'hover:dark:bg-[#182229] hover:bg-[#f8fafc]': workspace._id !== selectedWorkspace?._id
            }"
            (click)="selectWorkspace(workspace)"
        >
            <span class="flex items-center justify-between w-full">
                <span class="flex items-center">
                    <mat-icon class="mr-3 icon-size-5" [svgIcon]="'heroicons_mini:building-office'"></mat-icon>
                    <span>{{ workspace.name }}</span>
                </span>
                <span class="ml-3 flex items-center gap-2">
                    @if (workspace.role) {
                        <span
                            class="px-1.5 py-0.5 text-xs rounded-full"
                            [ngClass]="{
                                'bg-amber-500/10 dark:bg-amber-500/20 text-amber-600 dark:text-amber-400': workspace.role === 'admin',
                                'bg-purple-500/10 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400': workspace.role === 'supervisor',
                                'bg-emerald-500/10 dark:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400': workspace.role === 'configurator',
                                'bg-blue-500/10 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400': workspace.role === 'agent'
                            }"
                        >
                            {{ ('workspaces.roles.' + workspace.role) | transloco }}
                        </span>
                    }
                </span>
            </span>
        </button>
    }
</mat-menu>
